<template>
  <div class="code-container">
    <div class="code-input-container">
      <input
        ref="code-input"
        v-model="value"
        type="text"
        class="code-input"
        :style="{
          width: `${length * 70}px`,
          'caret-color': hideCaret ? 'transparent' : '',
        }"
        @input="handleInput"
        @keypress="isValid($event)"
        @focus="inputInFocus = true"
        @blur="inputInFocus = false"
      />
      <div class="code-input-markers">
        <div
          v-for="i in length"
          :key="i"
          class="code-input-marker"
          :class="{
            'code-input-marker_selected': inputInFocus && i === value.length + 1,
            'code-input-marker_warning': warning,
            'code-input-marker_success': success,
          }"
        />
      </div>
    </div>
    <div v-if="codeSending" class="code-input-info text text-grey">
      <!--TODO: плюрализация-->
      {{ $t('Request the code again in') }} {{ seconds }} {{ $t('seconds') }}
    </div>
    <button v-else class="code-input-info btn-link" @click="sendCodeAgain">
      <span v-if="warning" class="text code-input-info code-input-info_warning">
        {{ $t('Wrong code.') }}
      </span>
      {{ $t('Send code again') }}
    </button>
  </div>
</template>

<script>
  const SECONDS_LEFT = 30;

  export default {
    name: 'CodeInput',
    props: {
      length: {
        type: Number,
        default: 4,
        required: true,
      },
      warning: {
        type: Boolean,
        default: false,
      },
      success: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        value: '',
        codeSending: false,
        seconds: SECONDS_LEFT,
        interval: null,
        inputInFocus: false,
      };
    },
    computed: {
      hideCaret() {
        return this.value.length === this.length;
      },
    },
    mounted() {
      this.$refs['code-input'].focus();
    },
    methods: {
      handleInput() {
        if (this.value.length === 4) {
          this.$emit('send', this.value);
        }
      },
      isValid(evt) {
        evt = evt ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        // Only numbers without signs
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
          // if (this.value.length === this.length) this.$emit('send', this.value);
          evt.preventDefault();
        } else if (this.value.length >= this.length) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      sendCodeAgain() {
        this.codeSending = true;
        this.$emit('resend');
        this.interval = setInterval(() => {
          this.seconds = this.seconds - 1;
          if (this.seconds === 0) {
            clearInterval(this.interval);
            this.codeSending = false;
            this.seconds = SECONDS_LEFT;
          }
        }, 1000);
      },
    },
  };
</script>
